/**
 * Returns whether a value is null.
 */
export function isNull(val) {
  return val === null;
}

/**
 * Returns whether a value is null or undefined.
 */
export function isNullish(val) {
  return val === null || val === undefined;
}

/**
 * Returns whether a value is defined.
 */
export function isDefined(val) {
  return val !== undefined;
}

/**
 * Returns whether a value is undefined.
 */
export function isUndefined(val) {
  return val === undefined;
}

/**
 * Returns whether a value is an object.
 */
export function isObject(val) {
  return typeof val === "object" && val !== null;
}

/**
 * Returns whether a value is a function.
 */
export function isFunction(val) {
  return typeof val === "function";
}

/**
 * Returns whether a value is a number.
 */
export function isNumber(val) {
  return typeof val === "number";
}

/**
 * Returns whether a value is a string.
 */
export function isString(val) {
  return typeof val === "string";
}

/**
 * Returns whether a value is an empty string.
 */
export function isEmptyString(val) {
  return isString(val) && val.length === 0;
}

/**
 * Returns whether a value is a non-empty string.
 */
export function isNonEmptyString(val) {
  return isString(val) && val.length !== 0;
}